import { ViteReactSSG } from 'vite-react-ssg'

import { installChunkErrorRecovery } from './lib/chunk-reload'
import { initSentry, installBlankScreenWatchdog } from './lib/sentry'
import { routes } from './routes'

// Start error/replay reporting before anything else boots so a crash during the
// earliest render is still captured. Both calls are no-ops during SSG prerender
// and when no Sentry DSN is configured.
initSentry()
installBlankScreenWatchdog()
// Auto-recover from stale/failed code-split chunks (e.g. after a deploy or a
// flaky mobile connection) by reloading once. No-op during SSG prerender.
installChunkErrorRecovery()

export const createRoot = ViteReactSSG({ routes })
